import { AccessLevel, Route } from 'src/routes/Route'
import { Subroute } from 'src/routes/Subroute'
import { ActConfigRoute } from './ActConfiguration'
import { ActCheckoutRoute } from './ActCheckout'
import { ActSuccessRoute } from './ActSuccess'

const ActSubroute = Subroute(ActConfigRoute, ActCheckoutRoute, ActSuccessRoute)
export type ActSubroute = Subroute<typeof ActSubroute>

export const ActRoute = Route({
  path: '/act',
  accessLevel: AccessLevel.PUBLIC,
  init: (subroute?: ActSubroute) => ({
    subroute,
  }),
  fromPath: () => ({}),
  subroute: ActSubroute,
  hideSidebar: true,
})
export type ActRoute = Route<typeof ActRoute>
